// extracted by mini-css-extract-plugin
export var content = "_si-1";
export var wrapper = "_si-0";